// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"392":"b0567b3b","446":"b42d2bc2","453":"44061c7c","599":"66b43fdf","769":"012449e1"}[chunkId] + ".chunk.js";
};